import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PlatformDto} from '../../../../../Models/Tasks/General/task.interface';

@Component({
  selector: 'app-platform-item',
  templateUrl: './platform-item.component.html',
  styleUrls: ['./platform-item.component.scss'],
  standalone: false
})
export class PlatformItemComponent {
  @Input() platform!: PlatformDto;
  @Input() isButton: boolean = true;

  @Output() clickOpenPlatform: EventEmitter<void> = new EventEmitter<void>();
}
